// Main Page that displays algorithm visualizer and accepts user input
import Navbar from "./Navbar";
import AlgorithmList from "./AlgorithmView/AlgorithmList";
import GraphVisualizer from "./AlgorithmView/GraphVisualizer";

import React from 'react';
import "./MainPage.css"

export default function MainPage() {
  return (
    <div className="main-container">
         {/* Top Navbar */}
         <div className="navbar">
          <Navbar/>
        </div>

        {/* Main content */}
        <div className="main-content">
          {/* Left section */}
          <div className="left-section">
            <AlgorithmList/>
          </div>
            {/* Right section */}
            <div className="right-section">
                <GraphVisualizer />
            </div>
        </div>

        {/* Bottom section */}
        {/* <div className="bottom-section">
          <UserForm/>   
        </div>  */}
    </div>
  );
};
